import {
  Box,
  Button,
  TabList,
  Tabs,
  Tab,
  TabPanels,
  TabPanel,
  Image,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { Virus } from "./AllIcons";
import Slider from "../slider/Slider";

function RmCarousel() {
  const [tabIndex, setTabIndex] = useState(0);

  // const handleSliderChange = (event) => {
  //   setTabIndex(parseInt(event.target.value, 10));
  // };

  useEffect(() => {
    if (tabIndex !== 2) {
      setTimeout(() => {
        setTabIndex((i) => i + 1);
      }, 4000);
    } else {
      setTimeout(() => {
        setTabIndex(0);
      }, 4000);
    }
  }, [tabIndex]);

  // const handleTabsChange = (index) => {
  //   setTabIndex(index);
  // };
  return (
    <Box maxW="1500px" margin="auto">
      {/* <Box>
        <Carousel>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://s.rmjo.in/AirOKWeb%20(1).png"
              alt="First slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src="https://s.rmjo.in/WP-Web.png"
              alt="Second slide"
            />
          </Carousel.Item>
        </Carousel>
      </Box>
      <Box bgColor="#d4e0e9" padding="10px" borderBottomRadius="28px">
        {" "}
        <Virus fontSize="30px" /> Safety precautions during COVID-19. We’re
        taking additional steps and precautionary measures to protect our
        community from COVID-19. <Button variant="link">Know more</Button>
      </Box> */}
      <Box bg={"#d4e0e9"} borderRadius="30px">
        <Slider />
        <Box bgColor="#d4e0e9" padding="10px" borderBottomRadius="28px">
          {" "}
          <Virus fontSize="30px" /> Safety precautions during COVID-19. We’re
          taking additional steps and precautionary measures to protect our
          community from COVID-19. <Button variant="link">Know more</Button>
        </Box>
      </Box>
    </Box>
  );
}

export default RmCarousel;
